import React from 'react';
import { Link } from 'react-router-dom';

interface TestimonialProps {
  name: string;
  testimonial: string;
  beforeImage: string;
  afterImage: string;
}

const TestimonialCard: React.FC<TestimonialProps> = ({ name, testimonial, beforeImage, afterImage }) => {
  const baseUrl = window.location.origin;
  
  return (
    <div className="flex flex-col">
      <div className="flex justify-center space-x-4 mb-4">
        <div className="relative">
          <div className="absolute top-2 left-2 bg-black/70 text-white px-3 py-1 rounded-md font-semibold">
            BEFORE
          </div>
          <img 
            src={`${baseUrl}${beforeImage}`}
            alt={`${name} before`} 
            className="w-48 h-64 object-cover"
          />
        </div>
        <div className="relative">
          <div className="absolute top-2 left-2 bg-red-600/90 text-white px-3 py-1 rounded-md font-semibold">
            AFTER
          </div>
          <img 
            src={`${baseUrl}${afterImage}`}
            alt={`${name} after`} 
            className="w-48 h-64 object-cover"
          />
        </div>
      </div>
      <div className="bg-gray-900/50 backdrop-blur-sm p-6">
        <h3 className="text-2xl font-semibold text-white mb-2">{name}</h3>
        <p className="text-gray-300 italic">
          {testimonial}
        </p>
        <Link to="/client-results" className="text-red-500 hover:text-red-400 mt-2 inline-block transition-colors">
          Read More
        </Link>
      </div>
    </div>
  );
};

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      name: "Kelvin",
      testimonial: "I also struggled with my weight, but with a right plan in place and a clear goal i was able to loose 10+kg in only 10 weeks...",
      beforeImage: "/kbefore.png",
      afterImage: "/kafter.png"
    },
    {
      name: "Nick",
      testimonial: "Through dedicated training and nutrition guidance, Nick achieved an impressive body transformation, showcasing what's possible with the right program and commitment...",
      beforeImage: "/nfrontbefore.png.JPEG",
      afterImage: "/nfrontafter.png.JPEG"
    },
    {
      name: "Elliot",
      testimonial: "With an urgent deadline and having very minimal progress, once Elliot joined the program he was able to transform his body and loose 4kg in 4 weeks...",
      beforeImage: "/brobefore.JPG",
      afterImage: "/broafter.JPG"
    },
    {
      name: "Declan",
      testimonial: "His goal was to bulk up quickly and he was able to achieve this with a custom made plan whihc helped him gain 3kg in only 2 weeks and he is still going strong...",
      beforeImage: "/bbefore.png",
      afterImage: "/bafter.png"
    }
  ];

  return (
    <section className="bg-gradient-to-b from-black to-gray-900 py-20" id="results">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">SUCCESS STORIES</h2>
          <h3 className="text-base md:text-xl font-light text-white mb-4">Here are some of our clients and their stories</h3>
          <div className="w-16 h-1 bg-red-600 mx-auto"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard
              key={index}
              name={testimonial.name}
              testimonial={testimonial.testimonial}
              beforeImage={testimonial.beforeImage}
              afterImage={testimonial.afterImage}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;